import { TrashSimple } from "@phosphor-icons/react"
import { Button, Commandbar } from "~/components/design-system/components"
import { ResolveViolationsSelectionButtons } from "~/components/planning/ResolveViolationsButtons"
import { ConfirmationDialog } from "~/components/reusable/ConfirmationDialog"

type MultiEditPurchaseOrderSkuPanelProps = {
  selectedCount: number
  onRemove: () => void
  onClear: () => void
  onResolveMoqViolations: () => void
  onResolveColliViolations: () => void
  /** Short secondary-MOQ groups with only some of their SKUs selected: Resolve MOQ skips them. */
  partialMoqGroupCount: number
  groupName: string
}

export default function MultiEditPurchaseOrderSkuPanel({
  selectedCount,
  onRemove,
  onClear,
  onResolveMoqViolations,
  onResolveColliViolations,
  partialMoqGroupCount,
  groupName,
}: MultiEditPurchaseOrderSkuPanelProps) {
  return (
    <Commandbar count={selectedCount} onClear={onClear} selectedText="Selected SKUs">
      <ResolveViolationsSelectionButtons
        partialGroupCount={partialMoqGroupCount}
        groupName={groupName}
        onResolveMoq={onResolveMoqViolations}
        onResolveColli={onResolveColliViolations}
      />
      <ConfirmationDialog
        title="Remove SKUs from purchase order"
        description={`Are you sure you want to remove ${selectedCount} SKU${selectedCount > 1 ? "s" : ""} from this purchase order?`}
        onConfirm={onRemove}
        variant="danger"
        confirmText="Remove"
        trigger={
          <Button variant="neutral" size="sm">
            <TrashSimple />
            Remove
          </Button>
        }
      />
    </Commandbar>
  )
}
